module.exports = __webpack_public_path__ + "img/pic_brazil_02.4ec2ddce.jpg";